import { ImageVariant } from 'FeatureModules/Media/types/media.types';
import { IBasePartnerCompany } from 'FeatureModules/Partner/types/partner.types';
import { ISite } from 'FeatureModules/Site/types/site.types';
import { IGraphQlConnection } from 'types/core.types';

export enum EDocumentCategory {
  'MANAGEMENT_LETTER' = 'MANAGEMENT_LETTER',
  'CERTIFICATE' = 'CERTIFICATE',
  'SHAREHOLDER_AGREEMENT' = 'SHAREHOLDER_AGREEMENT',
  'PICTURES' = 'PICTURES',
  'LABORATORY_TEST' = 'LABORATORY_TEST',
  'REPORT' = 'REPORT',
  'STATEMENT' = 'STATEMENT',
  'GEOGRAPHICAL_FEATURES' = 'GEOGRAPHICAL_FEATURES',
  'OTHER' = 'OTHER',
}

export enum EDocumentStatus {
  EXPIRED = 'EXPIRED',
  VALID = 'VALID',
}

export enum EDocumentVisibilityStatus {
  PRIVATE = 'PRIVATE',
  // Disabled for now until we develop the partner autocomplete
  SELECTED = 'SELECTED',
  PUBLIC = 'PUBLIC',
}

export type TDocumentCategory = `${EDocumentCategory}`;

export type TDocumentStatus = `${EDocumentStatus}`;

export type TDocumentVisibilityStatus = `${EDocumentVisibilityStatus}`;

export interface IBaseDocument {
  id: string;
  title: string;
  path: string;
  url: string;
  expiryDate?: Date;
  issuedDate?: Date;
  category?: TDocumentCategory;
  createdTimestamp: Date;
  status: TDocumentStatus;
  impactClaimCount?: number;
  usageCount?: number;
  certificateCatalogItem?: ICertificateCatalogItem;
  visibility: TDocumentVisibilityStatus;
  createdBy: {
    id: string;
    name: string;
    logo?: ImageVariant;
  };
}
export interface IDocument extends IBaseDocument {
  ownedBy?: IBasePartnerCompany;
  linkedSites?: IGraphQlConnection<ISite>;
  comment?: string;
}
export interface ICertificateCatalogItems {
  edges: ICertificateCatalogItemNode[];
}

export interface ICertificateCatalogItemNode {
  node: ICertificateCatalogItem;
}

export interface ICertificateCatalogItem {
  id: string;
  description: string;
  imageUrl?: string;
  title: string;
  status?: string;
  requestedByUserEmail?: string;
  requestedTimestamp?: string;
}
export enum EDocumentCollaborationType {
  INTERNAL = 'INTERNAL',
  SHARED = 'SHARED',
}

export enum EDocumentLibraryTabs {
  INTERNAL = 'internal',
  SHARED = 'shared',
}

export enum EDocumentOverviewType {
  INTERNAL = 'internal',
  SHARED = 'shared',
  PARTNER = 'partner',
}
